'use client';

import { FC, PropsWithChildren } from 'react';
import { StyleGuidesProvider } from './_context/StyleGuidesContext';
import StyleGuidesRouterProvider from './_context/StyleGuidesRouterProvider';

const StyleGuidesLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <StyleGuidesProvider>
      <StyleGuidesRouterProvider>{children}</StyleGuidesRouterProvider>
    </StyleGuidesProvider>
  );
};

export default StyleGuidesLayout;
